<template>
<customdialog v-model="dialog" :maxWidth="options.width" :title="title" :cardtextstyle="'height: 160px;'">

  <v-card-text v-show="!!message">{{ message }}</v-card-text>
  <v-checkbox v-show="!!options.message" v-model="onay" color="green">
    <div slot="label">
      {{options.message}}
    </div>
  </v-checkbox>

  <template slot="btn">
    <v-btn color="primary" flat @click.native="yes()">{{btnYesCaption}}</v-btn>
  </template>

</customdialog>
</template>

<script>
import customdialog from "@/components/app/coper/comp/customdialog.vue";

export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      onay: false,
      btnYesCaption: 'EVET',
      messageShowDialog: false,

      options: {
        color: "primary",
        width: 380,
        message: null
      }
    };
  },
  components: {
    customdialog
  },
  methods: {
    open(title, message, options) {
      this.btnYesCaption = "EVET"
      this.messageShowDialog = false
      this.onay = false;
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    messageShow(title, message, options) {
      this.btnYesCaption = "KAPAT"
      this.messageShowDialog = true
      this.onay = false;
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = {
        color: "primary",
        width: 380,
        message: null
      }
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    yes() {
      if (this.options.message) {
        if (this.onay) {
          this.resolve(true);
          this.dialog = false;
        }
      } else {
        this.resolve(true);
        this.dialog = false;
      }
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }
};
</script>
